export type MeldingResp = { id?: number; status?: string } | string;

export const isSuccesResponse = (resp: MeldingResp | null): boolean => {
  if (!resp) return false;

  if (typeof resp === 'string') {
    return resp.toUpperCase() === 'SUCCES';
  }

  if (typeof resp.status === 'string') {
    return resp.status.toUpperCase() === 'SUCCES';
  }

  if (typeof resp.id === 'number') {
    return true;
  }

  return false;
};
